<template>
  <div
    id="overlay-detail"
    class="overlay__detail overlay__detail--opened"
    data-gtm-overlay-detail
    data-overlay-detail
    data-overlay-close
    >
    <div
      :class="`overlay__detail__work spinner ${showSpinner()}`"
      >
      <a
        v-show="imageLoaded"
        class="overlay__detail__work__link"
        data-gtm="from overlay detail - clicks object"
        data-overlay-detail-link
        :href="workLink"
        >
        <div class="work--in-list__image-container">
          <picture class="picture--start">
            <img
              :src="ImageURL"
              class="picture__img--static"
              data-overlay-image
              data-overlay-prevent-close
              data-toggle-controls
              draggable="false"
              onerror="window.MoMA.onImageError(this, 1)"
              @load="onImgLoad"
            >
          </picture>
        </div>
        <div class="work--in-list__caption-container">
          <h3 class="work--in-list__caption">
            <span
              class="work--in-list__caption__text--opaque"
              data-overlay-prevent-close
              v-html="Artist"
            />
            <span
              class="work--in-list__caption__text--opaque"
              data-overlay-prevent-close
              v-html="Title"
            />
            <span
              class="work--in-list__caption__text--opaque"
              data-overlay-prevent-close
              v-html="DisplayDate"
            />
          </h3>
        </div>
        <div class="work--in-list__call-to-action">
          <div
            class="icon-link"
            data-overlay-prevent-close
            v-html="learnMore"
          />
        </div>
      </a>
      <div class="overlay__detail__close">
        <a
          aria-label="Close overlay"
          class="controls__link"
          data-overlay-detail-close
          href="#"
          role="button"
          @click.prevent="closeOverlayDetail"
          v-html="close"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { embedSVG, addSvgToEnd } from 'Helpers/embedSVG';
  import * as focusTrap from "focus-trap";

  export default {
    props: {
      ID: { type: Number, required: true },
      Title: { type: String, required: true },
      Artist: { type: String, required: true },
      DisplayDate: { type: String, required: true },
      ImageURL: { type: String, required: true },
      srcElement: { type: HTMLElement, required: true },
    },

    data: function() {
      return {
        imageLoaded: false,
        focusTrapInstance: null
      };
    },

    computed: {
      workLink() {
        return `/collection/works/${this.ID}`;
      },

      learnMore() {
        return addSvgToEnd("Learn more", "icon-link__text--list", "icon__arrow--16--stroke.svg", "icon-link__svg");
      },

      close() {
        return embedSVG("icon__x--24--stroke.svg", "controls__link__svg--close");
      },
    },

    watch: {
      imageLoaded() {
        if (this.imageLoaded) {
          this.$nextTick(() => {
            this.initializeFocusTrap();
          });
        }
      }
    },

    methods: {
      onImgLoad() {
        this.imageLoaded = true;
      },
      showSpinner() {
        if (!this.imageLoaded) {
          return "spinner--visible";
        }

        return "";
      },
      closeOverlayDetail() {
        this.focusTrapInstance?.deactivate();
        this.$emit("onClickCloseOverlayWorkDetail");
      },
      initializeFocusTrap() {
        const overlayDetailContainer = document.getElementById("overlay-detail");
        this.focusTrapInstance = focusTrap.createFocusTrap(overlayDetailContainer, {
          setReturnFocus: this.srcElement
        });
        this.focusTrapInstance?.activate();
      }
    }
  };
</script>
